import React from "react";
import clsx from "clsx";

import styles from "./index.module.scss";

interface PageHeadProps extends React.PropsWithChildren {
  /** What the screen is called. */
  title: React.ReactNode;
}

/**
 * A screen's own heading row: its name, and the actions that belong to the
 * whole screen at the far end.
 *
 * Layout renders a page title of its own when it is given one, but only a
 * title — nothing can stand beside it. Every screen that needs a button up
 * there renders its own row instead, and three of them had written the same
 * two rules to do it.
 *
 * `transparent` because Layout treats each direct child of the content area as
 * a white card; this row is not one, the cards are below it.
 */
export default function PageHead({ title, children }: PageHeadProps) {
  return (
    <div className={clsx("transparent", styles.head)}>
      <h2 className={styles.title}>{title}</h2>
      {children}
    </div>
  );
}
